import Shield from './Shield';

export default Shield;
